import * as d3 from "d3";
import d3Tip from "d3-tip";
import store from "@/store"
import axios from "axios";
import moment from "moment";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import {apiAbort} from "@/common/apiAbort";

export function format(x) {
    var str = String(x);
    var arr = [];
    var i = str.indexOf(".");
    var j;
    if (i === -1) {
        i = str.length;
    } else {
        for (j = str.length - 1; j > i; j--) {
            arr.push(str[j]);
        }
        arr.push(".");
    }
    i--;
    for (j = 0; i >= 0; i--, j++) {
        if (j > 2 && (j % 2 === 1)) {
            arr.push(",");
        }
        arr.push(str[i]);
    }
    return arr.reverse().join("");
}

export function resetFilterFlagTabalebarChart(val){
    store.commit('setResetSortFlag',val);
}

export function inrFormatterV2(num, menuId) {

    // ✅ allow 0 also
    if (num !== null && num !== undefined) {

        const config = store.state.fwConfigScreenElement.find(
            a => a.menuId === menuId
        );
        const clientConfig = store.state.fwMClient[0];

        // Read decimal precision from clientConfigParam JSON; fallback to 2.
        let decimalPlaces = 2;
        try {
            const rawClientConfigParam = clientConfig?.clientConfigParam;
            const parsedClientConfigParam =
                typeof rawClientConfigParam === 'string'
                    ? JSON.parse(rawClientConfigParam)
                    : rawClientConfigParam;

            const configuredDecimals = parsedClientConfigParam?.decimalNumber;
            if (Number.isInteger(configuredDecimals) && configuredDecimals >= 0) {
                decimalPlaces = configuredDecimals;
            }
        } catch (e) {
            decimalPlaces = 2;
        }

        const numberSystem =
            config?.numberSystem || clientConfig.numberSystem;

        const numberDisplayType =
            config?.numberDisplayType || clientConfig.numberDisplayType;

        // ✅ Dynamic decimal formatter from client config (default 2)
        const formatDecimal = (value) => Number(value).toFixed(decimalPlaces);

        // ✅ Abbreviation formatter
        const abbreviate = (value, divisor, suffix) =>
            formatDecimal(value / divisor) + suffix;

        /* ================= INDIAN SYSTEM ================= */
        if (numberSystem === 'Indian') {

            if (numberDisplayType === 'abrv') {

                if (Math.abs(num) >= 1000000000)
                    return abbreviate(num, 1000000000, ' HCr');

                if (Math.abs(num) >= 10000000)
                    return abbreviate(num, 10000000, ' Cr');

                if (Math.abs(num) >= 100000)
                    return abbreviate(num, 100000, ' L');

                if (Math.abs(num) >= 1000)
                    return abbreviate(num, 1000, ' K');

                return formatDecimal(num);
            }

            // ✅ Indian comma format
            let formattedNum = formatDecimal(num);
            let numParts = formattedNum.split(".");

            let wholeNumber = numParts[0];
            let decimalPart = "." + numParts[1];

            let formattedWholeNumber =
                wholeNumber.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

            return formattedWholeNumber + decimalPart;
        }

        /* ================= INTERNATIONAL SYSTEM ================= */
        else {

            if (numberDisplayType === 'abrv') {

                if (Math.abs(num) >= 1000000000000)
                    return abbreviate(num, 1000000000000, ' T');

                if (Math.abs(num) >= 1000000000)
                    return abbreviate(num, 1000000000, ' B');

                if (Math.abs(num) >= 1000000)
                    return abbreviate(num, 1000000, ' M');

                if (Math.abs(num) >= 1000)
                    return abbreviate(num, 1000, ' K');

                return formatDecimal(num);
            }

            return Number(num).toLocaleString("en-US", {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces
            });
        }

    } else {
        return num;
    }
}


export function inrFormatter(num) {
//console.log("Store variable",store.state.clientId)
    if (store.state.fwMClient[0].numberSystem === 'Indian') {
        /*if (Math.abs(num) >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' HCr';
    }*/
        if (Math.abs(num) >= 10000000) {
            return (num / 10000000).toFixed(1).replace(/\.0$/, '') + ' Cr';
        }
        if (Math.abs(num) >= 100000) {
            return (num / 100000).toFixed(1).replace(/\.0$/, '') + ' L';
        }
        if (Math.abs(num) >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
            return num.toFixed(1);
        }
        return num;
    } else {
        if (Math.abs(num) >= 1000000000000) {
            return (num / 1000000000000).toFixed(1).replace(/\.0$/, '') + ' T';
        }
        if (Math.abs(num) >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' B';
        }
        if (Math.abs(num) >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + ' M';
        }
        /*if (Math.abs(num) >= 100000) {
            return (num / 100000).toFixed(1).replace(/\.0$/, '') + ' L';
        }*/
        if (Math.abs(num) >= 10000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
            return num.toFixed(2);
        }
        return num;
    }
}

// gridlines in x axis function
export function make_x_gridlines(x) {
    return d3.axisBottom(x)
        .ticks(10)
}

// gridlines in y axis function
export function make_y_gridlines(y) {
    return d3.axisLeft(y)
        .ticks(10)
}

export function d3Bullet(chart) {
    var orient = 'bottom', // TODO top & bottom
        reverse = false,
        duration = 0,
        ranges = bulletRanges,
        markers = bulletMarkers,
        measures = bulletMeasures,
        tickFormat = null

    function bulletRanges(d) {
        return d.ranges
    }

    function bulletMarkers(d) {
        return d.markers
    }

    function bulletMeasures(d) {
        return d.measures
    }

    function bulletTranslate(x) {
        return function (d) {
            return 'translate(' + x(d) + ',0)'
        }
    }

    function bulletWidth(x) {
        var x0 = x(0)
        return function (d) {
            return Math.abs(x(d) - x0)
        }
    }

    // For each small multiple…
    function bullet(g) {
        g.each(function (d, i) {
            var rangez = ranges.call(this, d, i).slice().sort(d3.descending),
                markerz = markers.call(this, d, i).slice().sort(d3.descending),
                measurez = measures.call(this, d, i).slice().sort(d3.descending),
                g = d3.select(this)

            // Compute the new x-scale.
            var x1 = d3.scaleLinear()
                .domain([0, Math.max(rangez[0], markerz[0], measurez[0])])
                .range(reverse ? [chart.width, 0] : [0, chart.width])

            // Retrieve the old x-scale, if this is an update.
            var x0 = this.__chart__ || d3.scaleLinear().domain([0, Infinity]).range(x1.range())

            // Stash the new scale.
            this.__chart__ = x1

            // Derive width-scales from the x-scales.
            var w0 = bulletWidth(x0),
                w1 = bulletWidth(x1)

            // Update the range rects.
            var range = g.selectAll('rect.range').data(rangez)

            range.enter()
                .append('rect')
                .attr('class', function (d, i) {
                    return 'range s' + i
                })
                .attr('width', w0)
                .attr('height', chart.height)
                .attr('x', reverse ? x0 : 0)
                .transition()
                .duration(duration)
                .attr('width', w1)
                .attr('x', reverse ? x1 : 0)

            range.transition()
                .duration(duration)
                .attr('x', reverse ? x1 : 0)
                .attr('width', w1)
                .attr('height', chart.height)

            // Update the measure rects.
            var measure = g.selectAll('rect.measure').data(measurez)

            measure.enter()
                .append('rect')
                .attr('class', function (d, i) {
                    return 'measure s' + i
                })
                .attr('width', w0)
                .attr('height', chart.height / 3)
                .attr('x', reverse ? x0 : 0)
                .attr('y', chart.height / 3)
                .transition()
                .duration(duration)
                .attr('width', w1)
                .attr('x', reverse ? x1 : 0)

            measure.transition()
                .duration(duration)
                .attr('width', w1)
                .attr('height', chart.height / 3)
                .attr('x', reverse ? x1 : 0)
                .attr('y', chart.height / 3)

            // Update the marker lines.
            var marker = g.selectAll('line.marker').data(markerz)

            marker.enter().append('line')
                .attr('stroke', '#000')
                .attr('stroke-width', '1.6px')
                .attr('x1', x0)
                .attr('x2', x0)
                .attr('y1', chart.height / 6)
                .attr('y2', chart.height * 5 / 6)
                .transition()
                .duration(duration)
                .attr('x1', x1)
                .attr('x2', x1)

            marker.transition()
                .duration(duration)
                .attr('x1', x1)
                .attr('x2', x1)
                .attr('y1', chart.height / 6)
                .attr('y2', chart.height * 5 / 6)

            // Compute the tick format.
            var format = tickFormat || x1.tickFormat(8)

            // Update the tick groups.
            var tick = g.selectAll('g.tick').data(x1.ticks(8), d => {
                return this.textContent || format(d)
            })

            // Initialize the ticks with the old scale, x0.
            var tickEnter = tick.enter().append('g')
                .attr('class', 'tick')
                .attr('transform', bulletTranslate(x0))
                .style('opacity', 1e-6)

            tickEnter.append('line').attr('y1', chart.height).attr('y2', chart.height * 7 / 6)

            tickEnter.append('text').attr('text-anchor', 'middle').attr('y', chart.height * 7 / 6).text(format)

            // Transition the entering ticks to the new scale, x1.
            tickEnter.transition().duration(duration).attr('transform', bulletTranslate(x1)).style('opacity', 1)

            // Transition the exiting ticks to the new scale, x1.
            tick.exit().transition()
                .duration(duration)
                .attr('transform', bulletTranslate(x1))
                .style('opacity', 1e-6)
                .remove()
        })
        d3.timerFlush()
    }

    // left, right, top, bottom
    bullet.orient = function (x) {
        if (!arguments.length) return orient
        orient = x
        reverse = orient === 'right' || orient === 'bottom'
        return bullet
    }

    // ranges (bad, satisfactory, good)
    bullet.ranges = function (x) {
        if (!arguments.length) return ranges
        ranges = x
        return bullet
    }

    // markers (previous, goal)
    bullet.markers = function (x) {
        if (!arguments.length) return markers
        markers = x
        return bullet
    }

    // measures (actual, forecast)
    bullet.measures = function (x) {
        if (!arguments.length) return measures
        measures = x
        return bullet
    }

    bullet.width = function (x) {
        if (!arguments.length) return chart.width
        chart.width = x
        return bullet
    }

    bullet.height = function (x) {
        if (!arguments.length) return chart.height
        chart.height = x
        return bullet
    }

    bullet.tickFormat = function (x) {
        if (!arguments.length) return tickFormat
        tickFormat = x
        return bullet
    }

    bullet.duration = function (x) {
        if (!arguments.length) return duration
        duration = x
        return bullet
    }
    return bullet
}

//responsive screen code
export function responsivefy(svg) {
    var container = d3.select(svg.node().parentNode),
        width = parseInt(svg.style('width')),
        height = parseInt(svg.style('height')),
        aspect = width / height;

    svg.attr('viewBox', '0 0 ' + width + ' ' + height)
        .attr('perserveAspectRatio', 'xMinYMid')
        .call(resize)

    d3.select(window).on('resize.' + container.attr('id'), resize)

    function resize() {
        var targetWidth = parseInt(container.style('width'))
        svg.attr('width', targetWidth)
        svg.attr('height', Math.round(targetWidth / aspect))
    }
}

export function tooltip_class() {
    var t_tip = d3Tip()
        .style('position', 'relative')
        .style('line-height', '1')
        .style('padding', '12px')
        .style('background', 'white')
        .style('border-radius', '5px')
        .style('position', 'absolute')
        .style('border-width', '.5px')
        .style('border-style', 'groove')

    return t_tip
}

export var createAxis = function (scaleType) {
    if (scaleType === "bandScale") {
        return d3.scaleBand()
    } else if (scaleType === "linearScale") {
        return d3.scaleLinear()
    } else if (scaleType === 'timeScale') {
        return d3.scaleTime()
    }
}

export function dashLine(line) {
    line.style("stroke-dasharray", '3.3');
}

export function addGridlines(svg, xScale, yScale, chart) {
    // add the X gridlines
    svg.append("g")
        .attr("class", "grid")
        .attr("transform", "translate(0," + chart.height + ")")
        .call(make_x_gridlines(xScale)
            .tickSize(-chart.height)
            .tickFormat(""))
        .style("stroke-width", 0.1);

    // add the Y gridlines
    svg.append("g")
        .attr("class", "grid")
        .call(make_y_gridlines(yScale)
            .tickSize(-chart.width)
            .tickFormat(""))
        .style("stroke-width", 0.1);
}

export function wrapsword(text, maxLength) {
    if (typeof text !== 'string') {
        // If text is not a string, convert it to a string
        text = String(text);
    }
    if (maxLength <= 0) {
        // If the length is less than or equal to 0, return the original text
        return text;
    }
    const characters = text.split(/( |,|_|(?=[A-Z]))/); // Splitting into individual characters
    let currentLine = '';
    const lines = [];

    characters.forEach((char) => {
        const potentialLine = currentLine + char;
        if (potentialLine.length <= maxLength) {
            currentLine = potentialLine;
        } else {
            lines.push(currentLine);
            currentLine = char;
        }
    });
    lines.push(currentLine);
    return lines.join('\n');
}


export function wraps(textSelection, maxCharacters, splitRegex) {
    if (maxCharacters == 0) {
        return textSelection;
    } else {
        textSelection.each(function () {
            var textElement = d3.select(this),
                text = textElement.text(),
                words = splitText(text, splitRegex),
                word,
                line = [],
                lineNumber = 0,
                lineHeight = 0.9, // ems
                y = textElement.attr("y"),
                dy = parseFloat(textElement.attr("dy")),
                tspan = textElement.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");

            function splitText(text, regex) {
                // Split text based on the provided regular expression
                return text.split(regex).filter(Boolean);
            }

            while ((word = words.shift()) !== undefined) {
                line.push(word);
                tspan.text(line.join(""));

                if (line.join("").length > maxCharacters) {
                    line.pop();
                    tspan.text(line.join(""));
                    line = [word];
                    const newDy = ++lineNumber * lineHeight + dy;
                    tspan = textElement.append("tspan").attr("x", 0).attr("y", y).attr("dy", newDy + "em").text(word);
                }
            }
        });
    }
}

export function generateDownloadData(chartConfig, globalFilters) {
    return chartConfig.map(item => ({
        title: item.label,
        action: function(elm, d) {
            // Get current origin and construct full URL
            const currentOrigin = window.location.origin;
            const fullUrl = `${currentOrigin}${item.url}`;

            // Store the origin dynamically (use current origin for postMessage)
            const targetOrigin = new URL(fullUrl).origin;
            const newWindow = window.open(fullUrl, '_blank');

            // More robust message sending with retries
            let attempts = 0;
            const maxAttempts = 10;

            const sendMessage = () => {
                if (newWindow.closed) return;

                if (attempts < maxAttempts) {
                    try {
                        newWindow.postMessage({
                            type: 'FILTER_DATA',
                            payload: {
                                globalFilters,
                                clickedData: d,
                                source: window.location.href
                            }
                        }, targetOrigin);

                        // console.log(`Attempt ${attempts + 1}: Message sent to ${targetOrigin}`);
                    } catch (e) {
                        console.error("PostMessage error:", e);
                    }

                    attempts++;
                    setTimeout(sendMessage, 200); // Retry every 200ms
                }
            };

            sendMessage();
            return d;
        }
    }));
}

export function contextMenu(menu, openCallback) {
    // create the div element that will hold the context menu
    d3.selectAll('.d3-context-menu')
        .data([1])
        .enter()
        .append('div')
        .attr('class', 'd3-context-menu');

    // close menu
    d3.select('body')
        .on('click.d3-context-menu', function () {
            d3.select('.d3-context-menu').style('display', 'none');
        });

    // this gets executed when a contextmenu event occurs
    return function (data, index) {
        var elm = this;

        d3.selectAll('.d3-context-menu').html('');
        var list = d3.selectAll('.d3-context-menu').append('ul');
        list.selectAll('li').data(menu).enter()
            .append('li')
            .html(function (d) {
                return d.title;
            })
            .on('click', function (d) {
                d.action(elm, data, index);
                d3.select('.d3-context-menu').style('display', 'none');
            });

        // the openCallback allows an action to fire before the menu is displayed
        // an example usage would be closing a tooltip
        if (openCallback) openCallback(data, index);

        // display context menu
        d3.select('.d3-context-menu')
            .style('left', (d3.event.pageX - 2) + 'px')
            .style('top', (d3.event.pageY - 2) + 'px')
            .style('display', 'block');

        d3.event.preventDefault();
    }
}

export function contextMenuTransport(menu, openCallback) {
    // create the div element that will hold the context menu
    d3.selectAll('.d3-context-menu')
        .data([1])
        .enter()
        .append('div')
        .attr('class', 'd3-context-menu');

    // close menu
    d3.select('body')
        .on('click.d3-context-menu', function () {
            d3.select('.d3-context-menu').style('display', 'none');
        });

    // this gets executed when a contextmenu event occurs
    return function (data, index) {
        var elm = this;

        d3.selectAll('.d3-context-menu').html('');
        var list = d3.selectAll('.d3-context-menu').append('ul');
        list.selectAll('li').data(menu).enter()
            .append('li')
            .html(function (d) {
                return d.title;
            })
            .on('click', function (d) {
                d.action(elm, data, index);
                d3.select('.d3-context-menu').style('display', 'none');
            });

        // the openCallback allows an action to fire before the menu is displayed
        // an example usage would be closing a tooltip
        if (openCallback) openCallback(data, index);

        // display context menu
        d3.select('.d3-context-menu')
            .style('left', (d3.event.pageX - 2) + 'px')
            .style('top', (d3.event.pageY - 2) + 'px')
            .style('display', 'block');

        d3.event.preventDefault();
    }
}

export function clearExpandedNodesFromStorage() {
    localStorage.removeItem('etl_expanded_node_keys');
}


export var colonAnnotation = ": ";
export var numberFormat = inrFormatter;
export var axisTextDim1 = function (d) {
    if (d && d.length > 10)
        return d.substring(0, 10) + "~... "
    else {
        let j = 10 - (d?.length || 0);
        for (let i = 1; i <= j; i++) {
            d = d + " .";
        }
        return d + " ."
    }
};
export var XaxisAttribute = function (d) {
    if (d && d.length > 7)
        return '-8em'
    else if (d && d.length <= 2)
        return '-3em'
    else
        return '-4.5em'
};
export var axisTextDim2 = function (d) {
    if (d.data.name.length > 15)
        return d.data.name.substring(0, 15) + "~ "
    else {
        let j = 15 - d.data.name.length;
        for (let i = 1; i <= j; i++) {
            d.data.name = d.data.name + " .";
        }
        return d.data.name + " ."
    }
};
export var axisTextDim3 = function (d) {
    if (d.length > 20)
        return d.substring(0, 20) + "~ "
    else {
        /*        let j= 20- d.length;
        for(let i=1; i <= j; i++) {
            d= d+ " .";
        }*/
        // return d+ " ."
        return d
    }
};
export var axisTextDim4 = function (d) {
    if (d.length > 10)
        return d.substring(0, 10) + "~ "
    else {
        /*        let j= 20- d.length;
                for(let i=1; i <= j; i++) {
                    d= d+ " .";
                }*/
        // return d+ " ."
        return d
    }
};


export var colourScheme = function (d) {
    const lowerCase = d.toLowerCase();
    if (lowerCase === "ylorrd") {
        return d3.interpolateYlOrRd;
    } else if (lowerCase === "blue") {
        return d3.interpolateBlues;
    } else if (lowerCase === "green") {
        return d3.interpolateGreens;
    } else if (lowerCase === "grey") {
        return d3.interpolateGreys;
    } else if (lowerCase === "orange") {
        return d3.interpolateOranges;
    } else if (lowerCase === "purple") {
        return d3.interpolatePurples;
    } else if (lowerCase === "red") {
        return d3.interpolateReds;
    } else if (lowerCase === "turbo") {
        return d3.interpolateTurbo;
    } else if (lowerCase === "viridis") {
        return d3.interpolateViridis;
    } else if (lowerCase === "schemeCategory10") {
        return d3.schemeCategory10;
    }
    return null;
}

export var fw_progressive_1way = d3.schemeCategory10;
export var fw_progressive_2way = d3.schemeSet3;
export var fw_progressive_3way = d3.schemeDark2;
export var fw_waterfall = ['#1f77b4', '#ADD8E6', '#90EE90', 'Red',];
export var pieChart = ["#bdd7e7", "#6baed6", "#2171b5", "#bae4b3", "#74c476", "#238b45"];
export var blueScheme = ['#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', "#08306b"];
export const DEFAULT_AXIS_FONT_SIZE = 10;
export const DEFAULT_AXIS_LABEL_FONT_SIZE = 14;

export var percentageSymbol = function (d) {
    if (d === 'pct') {
        return '%';
    }
    return null;
}


export var getTimeFormatter = function (firstDim4Name) {
    if (firstDim4Name === "YYYY") {
        return d3.timeFormat("%Y");
    } else if (firstDim4Name === "MonYY") {
        //Apr 24
        return d3.timeFormat("%b %Y");
    } else if (firstDim4Name === "MonYYYY") {
        return d3.timeFormat("%b %y");
    } else if (firstDim4Name === "YYYYWK") {
        return d3.timeFormat("%U %b %y");
    } else if (firstDim4Name === "YYYYMMDD") {
        return d3.timeFormat("%Y-%b-%d");
    }else if (firstDim4Name === "YYYY-MM-DD"){
        return d3.timeFormat("%Y-%m-%d");
    }else if(firstDim4Name === "MonDD"){
        return d3.timeFormat("%B %d");
    } else {
        return d3.timeFormat("%Y-%m");
    }
}
export var downloadDataTransport = [
    {
        title: '<a href="https://forewarn.compegence.com/#/viz-screen/I/I17" target="_blank" style="background-color:white;">Drilldown</a>',
        // title:'<a style="background-color:white;">Go For Drilldown Report</a>',
        action: function (elm, d) {
            return d;
        }
    }
]


export var downloadData = [
    {
        title: '<a href="https://forewarn.compegence.com/#/customer-drilldown-dyn/G/G01" target="_blank" style="background-color:white;">Drilldown Report</a>',
        // title:'<a style="background-color:white;">Go For Drilldown Report</a>',
        action: function (elm, d) {
            return d;
        }
    },
    {
        title: '<a href="https://forewarn.compegence.com/#/viz-screen/I/I11" target="_blank" style="background-color:white;">Return Analysis</a>',
        // title:'<a style="background-color:white;">Go For Drilldown Report</a>',
        action: function (elm, d) {
            return d;
        }
    }
]

// Tooltip utility function
export function createTooltip(divId) {
    // console.log("divid from create tooltip ", divId);
    // Create a tooltip div element (hidden by default)
    const tooltip = d3.select(divId)
        .append('div')
        .attr('class', 'tooltip')
        .style('position', 'absolute')
        .style('background-color', '#fff')
        .style('padding', '8px')
        .style('border-radius', '5px')

    // Function to handle mouseover event
    function onMouseOver(d, element, contentCallback, fontColor) {
        tooltip
            .style('opacity', 1) // Show tooltip
            .html(contentCallback(d)) // Set the tooltip content
            .style('left', d3.event.clientX - divId.getBoundingClientRect().left + "px") // Position tooltip horizontally
            .style('top', d3.event.clientX - divId.getBoundingClientRect().top + "px") // Position tooltip vertically
            .style("color", fontColor);
    }

    // Function to handle mousemove (for responsive positioning)
    function onMouseMove() {
        tooltip
            .style('left', d3.event.clientX - divId.getBoundingClientRect().left + "px") // Update X position
            .style('top', d3.event.clientY - divId.getBoundingClientRect().top + "px"); // Update Y position
    }

    // Function to handle mouseleave event
    function onMouseLeave() {
        tooltip.style('opacity', 0); // Hide tooltip
    }

    return {
        onMouseOver,
        onMouseMove,
        onMouseLeave
    };
}

export async function getAnnotationMsgcount() {
    // console.log("inside getAnnotationMsgcount");

    const url1 = "/api/session-current-user-log";

    try {
        const controller = apiAbort.new();  // 🔹 create abort controller
        const resp = await axios.get(url1,{
            signal: controller.signal
        });
        // console.log("resp", resp.data);

        let timestampMs;

        if (resp.data[0].messages_last_seen_at === null) {
            const controller = apiAbort.new();
            const resp2 = await axios.get('/api/session-log',{
                signal:controller.signal
            });
            // console.log("resp2", resp2.data);
            timestampMs = resp2.data[0].login_timestamp;
            // console.log("timestampMs", timestampMs);
        } else {
            timestampMs = resp.data[0].messages_last_seen_at;
        }


        // console.log("Timestamp to use:", timestampMs);

        const loginDate = new Date(Number(timestampMs));

        const pad = (num, size = 2) => String(num).padStart(size, "0");
        const formatted =
            loginDate.getFullYear() + "-" +
            pad(loginDate.getMonth() + 1) + "-" +
            pad(loginDate.getDate()) + " " +
            pad(loginDate.getHours()) + ":" +
            pad(loginDate.getMinutes()) + ":" +
            pad(loginDate.getSeconds()) + "." +
            pad(loginDate.getMilliseconds(), 3);

        // console.log("loggedInTimestamp", formatted);

        const url2 = "/api/user-annotations-after";
        const annotationsResp = await axios.post(url2, { timeStamp: formatted },{
            signal: controller.signal
        });

        const annotations = annotationsResp.data || [];
        const count = Array.isArray(annotations) ? annotations.length : 0;

        // console.log("annotations", annotations, "count:", count);

        store.commit("setAnnotationCount", count);

    } catch (error) {
        console.error("Error:", error);
    }
}


/**
 * Compare two cell values for table sorting.
 * Metrics from the API are often strings; coerce to number when both parse as finite numbers
 * so sort matches numeric magnitude (incl. Indian L/Cr display which uses raw base units in data).
 */
function compareSortCellValues(valA, valB) {
    const nA =
        typeof valA === "number" && Number.isFinite(valA)
            ? valA
            : typeof valA === "string" && valA.trim() !== ""
              ? Number(valA)
              : NaN;
    const nB =
        typeof valB === "number" && Number.isFinite(valB)
            ? valB
            : typeof valB === "string" && valB.trim() !== ""
              ? Number(valB)
              : NaN;
    if (Number.isFinite(nA) && Number.isFinite(nB)) {
        return nA - nB;
    }
    return String(valA).localeCompare(String(valB), undefined, {
        numeric: true,
        sensitivity: "base",
    });
}

export function multiColumnSort(columns, directions) {
    return function (a, b) {
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];
            const dir = directions[i];

            let valA = a[col];
            let valB = b[col];

            if (valA == null && valB == null) continue;
            if (valA == null) return dir === 'asc' ? -1 : 1;
            if (valB == null) return dir === 'asc' ? 1 : -1;

            let comparison = compareSortCellValues(valA, valB);

            if (dir === 'desc') {
                comparison = -comparison;
            }

            if (comparison !== 0) return comparison;
        }

        const origA = a.__originalIndex;
        const origB = b.__originalIndex;
        if (
            typeof origA === "number" &&
            typeof origB === "number" &&
            Number.isFinite(origA) &&
            Number.isFinite(origB)
        ) {
            return origA - origB;
        }
        return 0;
    };
}

// Recursive descendant check using nested tree structure
export function isDescendant(menuTree, allowedMenuIds, targetId) {
    if (!Array.isArray(menuTree) || !targetId) return false;

    function traverse(node, allowedMenuIds) {
        // If this node is allowed, check its descendants
        if (allowedMenuIds.includes(node.menuId)) {
            return containsTarget(node, targetId);
        }
        // Otherwise, check its children
        if (node.children && node.children.length > 0) {
            return node.children.some(child => traverse(child, allowedMenuIds));
        }
        return false;
    }

    function containsTarget(node, targetId) {
        if (node.menuId === targetId) return true;
        if (node.children && node.children.length > 0) {
            return node.children.some(child => containsTarget(child, targetId));
        }
        return false;
    }

    return menuTree.some(rootNode => traverse(rootNode, allowedMenuIds));
}

/** Trigger a browser download for a Blob (CSV, etc.). */
export function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

/** Convert inline CSV response to XLSX or CSV file on disk. */
export async function deliverExportFromCsvPayload(data, pendingDownloadFormat, base) {
    let csvStr;
    if (typeof data === "string") {
        csvStr = data;
    } else if (data instanceof ArrayBuffer) {
        csvStr = new TextDecoder().decode(data);
    } else {
        csvStr = String(data);
    }

    if (pendingDownloadFormat === "xlsx") {
        // Keep CSV values as-is (especially YYYY-MM-DD date strings) and
        // avoid Excel serial date conversion during workbook generation.
        const wb = XLSX.read(csvStr, {
            type: "string",
            raw: true,
            cellDates: false,
        });
        XLSX.writeFile(wb, `${base}.xlsx`);
    } else {
        const blob = new Blob([csvStr], { type: "text/csv;charset=utf-8;" });
        downloadBlob(blob, `${base}.csv`);
    }
}

function pollExportJob(jobId, {
    pendingDownloadFormat,
    baseName,
    toastInfo,
    toastPollError,
    onSuccess,
}) {
    if (toastInfo) {
        toastInfo(
            `We've started your download. Since it's a large file,
        it's processing in the background. You'll get a notification as soon as it's finished and available in your downloads.`,
            "Processing",
        );
    }

    const checkStatus = async () => {
        try {
            const response = await axios.get(`/api/exportStatus/${jobId}`);
            const status = response.data;

            if (status.status === "COMPLETED") {
                const downloadResponse = await axios.get(`/api/downloadExport/${jobId}`, {
                    responseType: "blob",
                });

                if (pendingDownloadFormat === "xlsx") {
                    const text = await downloadResponse.data.text();
                    const wb = XLSX.read(text, {
                        type: "string",
                        raw: true,
                        cellDates: false,
                    });
                    XLSX.writeFile(wb, `${baseName}.xlsx`);
                } else {
                    downloadBlob(downloadResponse.data, `${baseName}.csv`);
                }
                if (onSuccess) onSuccess();
            } else if (status.status === "FAILED") {
                if (toastPollError) toastPollError(status.errorMsg || "Export failed");
            } else {
                setTimeout(checkStatus, 10000);
            }
        } catch (e) {
            if (toastPollError) toastPollError("Error checking export status");
        }
    };

    checkStatus();
}

/**
 * POST /api/fetchCsvWithParam/... then deliver CSV/XLSX or poll async export (same flow as vizlet).
 *
 * @param {Object} opts
 * @param {string|null|undefined} opts.downloadsqlId
 * @param {string|null|undefined} opts.datasqlId  Used when downloadsqlId is null (non-Tabulator).
 * @param {string} opts.reportTitle  Viz/report title for URL and filenames.
 * @param {Object} opts.postBody  Request JSON body (e.g. lbWhereCond bucket).
 * @param {string} opts.menuId
 * @param {string} opts.submenuId
 * @param {'xlsx'|'csv'} opts.pendingDownloadFormat
 * @param {*} [opts.reportHeaderColumnDp]
 * @param {number|string} opts.userId
 * @param {AbortSignal} [opts.signal]
 * @param {function({ fileName: string, onHideLoading?: function(): void }): boolean} [opts.tryClientTabulatorDownload]
 * @param {function(): void} [opts.onShowLoading]
 * @param {function(): void} [opts.onHideLoading]
 * @param {function(string, string?): void} [opts.toastError]  Danger toast for request/parse errors.
 * @param {function(string, string): void} [opts.toastInfo]  Info toast (large file).
 * @param {function(string): void} [opts.toastPollError]  Danger toast for poll failures.
 * @param {function(): void} [opts.onPollSuccess]  e.g. show “download finished” modal.
 */
export async function runFetchCsvExport(opts) {
    const {
        downloadsqlId,
        datasqlId = null,
        reportTitle,
        postBody = {},
        menuId,
        submenuId,
        pendingDownloadFormat,
        reportHeaderColumnDp,
        userId,
        signal: abortSignalOpt,
        tryClientTabulatorDownload,
        onShowLoading,
        onHideLoading,
        toastError,
        toastInfo,
        toastPollError,
        onPollSuccess,
    } = opts;

    onShowLoading && onShowLoading();

    try {
        let datas = { ...postBody };
        if (
            reportHeaderColumnDp &&
            (downloadsqlId === null || downloadsqlId === "")
        ) {
            datas.reportHeaderColumnDp = reportHeaderColumnDp;
        }

        const vizTitle = reportTitle
            ? encodeURIComponent(String(reportTitle).replaceAll("/", "-"))
            : "undefined";
        const fileName =
            userId +
            "_" +
            reportTitle +
            "_" +
            moment().format("YYYY-MM-DD_hhmm");

        if (downloadsqlId === null) {
            if (typeof tryClientTabulatorDownload === "function") {
                const handled = tryClientTabulatorDownload({ fileName, onHideLoading });
                if (handled) {
                    return;
                }
            }
        }

        let url = "";
        if (downloadsqlId === null) {
            url = "/api/fetchCsvWithParam/" + datasqlId + "/" + vizTitle;
        } else {
            url = "/api/fetchCsvWithParam/" + downloadsqlId + "/" + vizTitle;
        }

        const ctrl = abortSignalOpt ? null : apiAbort.new();
        const response = await axios.post(url, datas, {
            signal: abortSignalOpt || ctrl.signal,
            headers: {
                "info-params": JSON.stringify({
                    menuId,
                    submenuId,
                }),
                "Content-Type": "application/json",
            },
        });

        onHideLoading && onHideLoading();

        const contentType = response.headers["content-type"];

        if (contentType && contentType.includes("text/csv")) {
            const base = `${userId}_${reportTitle}_${moment().format("YYYY-MM-DD_hhmm")}`;
            await deliverExportFromCsvPayload(response.data, pendingDownloadFormat, base);
        } else if (response.data && response.data.jobId) {
            const momentAll = `${moment().format("YYYY-MM-DD_hhmm")}`;
            const baseName = `${userId}-${reportTitle}-${momentAll}`;
            pollExportJob(response.data.jobId, {
                pendingDownloadFormat,
                baseName,
                toastInfo,
                toastPollError,
                onSuccess: onPollSuccess,
            });
        } else {
            console.error("Unexpected response:", response);
            if (toastError) toastError("Unexpected response from server");
        }
    } catch (e) {
        onHideLoading && onHideLoading();
        if (toastError) toastError("Error in loading the data for download");
        console.error("error in loading download data", e);
    }
}


